import React from "react";
import "./Header.css";

const Header = () => {
    return (
        <div className="header-logo">
            <div id="header">
                <header>
                    <div className="container">
                        <div className="topbar"></div>
                        <div className="mainbar">
                            <a href="https://www.onb.ac.at/" className="logo-link">
                                <img
                                    src={require("../../assets/images/logo.svg")}
                                    className="logo"
                                    alt="Österreichische Nationalbibliothek Logo"
                                    width="200"
                                    height="41"
                                />
                            </a>
                        </div>
                    </div>
                </header>
            </div>
        </div>
    );
};

export default Header;
